import { Box, Popover, Typography } from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "../../../../assets/SVG/closeIcon";
import MedicalRecordsIcon from "../../../../assets/SVG/medicalRecordsIcon";
import ParvandeIcon from "../../../../assets/SVG/parvandeIcon";
import FormReception from "./formReception";
import questionMark from "../../../../assets/image/questionMark.png";
import { InputCreateProject } from "../../../project/createProjectPop";
import { inquiryPatient } from "../../../../api/area";

export default function ReceptionPop({
  anchorEl,
  setAnchorEl,
  dataArea,
  ageType,
  setDataPatients
}) {
  const [selectedLevel, setSelectedLevel] = useState();
  const [selectedMode, setSelectedMode] = useState("irani");
  const [show, setShow] = useState(false);
  const [DATA, setDATA] = useState();
  const open = Boolean(anchorEl);
  const [nationalId, setNationalId] = useState();
  const [levelPop, setLevelPop] = useState(0);
  const id = open ? "simple-popover" : undefined;
  const handleOpen = () => setShow(true);
  const handleClose1 = () => {
    setShow(false);
  };
  const handleClose = () => {
    setAnchorEl(null);
    // setOpenPopover(false);
    // setDate();
    setDATA()
  };
  
  return (
    <Popover
      sx={{
        "& .MuiPaper-root": {
          width: "550px",
          height: "505px",
          padding: "22px 23px",
          borderRadius: "13px",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "#00000060",
        },
      }}
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Box
        onClick={handleClose}
        width="fit-content"
        sx={{ cursor: "pointer", mb: "10px" }}
      >
        <CloseIcon />
      </Box>
      {levelPop === 1 && !selectedLevel && (
        <Box
          height="470px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap="20px"
        >
          {/* {[
            {
              text: "صدور نوبت مجدد",
              mode: "issuing",
            },
            {
              text: "مشاهده پرونده پزشکی",
              mode: "view",
            },
          ].map((x, i) => (
            <> */}
          <Box
            display="grid"
            justifyItems={"center"}
            alignContent="center"
            gap="20px"
            borderRadius="15px"
            border="solid 3px #42C3CF "
            width="50%"
            height="190px"
            sx={{ cursor: "pointer" }}
            onClick={() => setSelectedLevel("issuing")}
          >
            <ParvandeIcon />
            <Typography color="#42C3CF">{ DATA? "صدور نوبت مجدد":"صدور نوبت"}</Typography>
          </Box>
          {DATA && (
            <Box
              display="grid"
              justifyItems={"center"}
              alignContent="center"
              gap="20px"
              borderRadius="15px"
              border="solid 3px #42C3CF "
              width="50%"
              height="190px"
              sx={{ cursor: "pointer" }}
              onClick={() =>
                window.open(
                  `/parvandeh?${dataArea[0]?.areas[0]?.id}&${
                    DATA?.identifier
                  }&${selectedMode === "irani" ? "NATIONAL_CODE" : "SRG"}&${
                    DATA?.id
                  }`,
                  "_blank"
                )
              }
            >
              <MedicalRecordsIcon />
              <Typography color="#42C3CF">{"مشاهده پرونده پزشکی"}</Typography>
            </Box>
          )}
          {/* </>
          ))} */}
        </Box>
      )}
      {selectedLevel && (
        <Box
          display="flex"
          width="150px"
          borderRadius={"9px"}
          bgcolor="#D6DAFF"
          gap="5px"
          p="3px 5px"
          sx={{ cursor: "pointer" }}
        >
          {[
            { text: "ایرانی", mode: "irani" },
            { text: "اتباع", mode: "citizens" },
          ].map((x) => (
            <Typography
              onClick={() => setSelectedMode(x.mode)}
              p="3px"
              width="50%"
              textAlign="center"
              bgcolor={selectedMode === x.mode && "#126E83"}
              borderRadius={"9px"}
              color={selectedMode === x.mode ? "white" : "#787878"}
              sx={{ transition: "0.3s all" }}
            >
              {x.text}
            </Typography>
          ))}
        </Box>
      )}
      {selectedLevel === "issuing" && (
        <>
          {DATA ? (
            <FormReception
            setDataPatients={setDataPatients}
              DATA={DATA}
              ageType={ageType}
              dataArea={dataArea}
              handleClose={handleClose}
              mode={selectedMode}
              setLevelPop={setLevelPop}
              setSelectedLevel={setSelectedLevel}
              />
              ) : (
                <FormReception
                setDataPatients={setDataPatients}
                nationalId={nationalId}
                handleClose={handleClose}
                ageType={ageType}
                dataArea={dataArea}
                mode={selectedMode}
                setLevelPop={setLevelPop}
                setSelectedLevel={setSelectedLevel}
            />
          )}
        </>
      )}
      {levelPop === 0 && (
        <>
          {/* {DATA ? (
            <FormReception
            DATA={DATA}
              ageType={ageType}
              dataArea={dataArea}
              mode={selectedMode}
            />
          ) : ( */}
          <>
            <Box
              display="grid"
              height="370px"
              gap="20px"
              justifyItems={"center"}
              alignContent="center"
            >
              <img src={questionMark} />
              <Typography color="#787878" fontWeight={"bold"}>
                استعلام وضعیت پرونده بیمار
              </Typography>
              <InputCreateProject
                placeholder={
                  selectedMode === "irani"
                    ? "کد ملی بیمار را وارد کنید. "
                    : "کد اتباع بیمار را وارد کنید."
                }
                // label="جنسیت / نام و نام خانوادگی"
                value={nationalId}
                onChange={(e) => setNationalId(e.target.value)}
              />
            </Box>
            <button
              onClick={() => {
                if (nationalId && dataArea) {
                  inquiryPatient(dataArea[0]?.areas[0]?.id, {
                    identifier: nationalId,
                    identifierType:
                      selectedMode === "irani" ? "NATIONAL_CODE" : "SRG",
                  })
                    .then((x) => {
                      setDATA(x);
                      setLevelPop(1);
                    })
                    .catch(() => {
                      setLevelPop(1);
                    });
                }
              }}
              style={
                nationalId && dataArea
                  ? {}
                  : { opacity: "0.5", cursor: "no-drop" }
              }
              className="btnCreate"
            >
              {"استعلام "}
            </button>
          </>
          {/* )} */}
        </>
      )}
    </Popover>
  );
}
